export default __webpack_public_path__ + "static/media/contact.36c2b3e4.svg";